export const ExpertPath = '/experts';

export const ExpertUrls = {
  page: `${ExpertPath}`,
};
